/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_UnlistedInputs */

const cs_enum_unlisted = /** @type {(inputs: Enum_UnlistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skryté`)
};

const en_enum_unlisted = /** @type {(inputs: Enum_UnlistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlisted`)
};

/**
* | output |
* | --- |
* | "Unlisted" |
*
* @param {Enum_UnlistedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_unlisted = /** @type {((inputs?: Enum_UnlistedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_UnlistedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_unlisted(inputs)
	return cs_enum_unlisted(inputs)
});